'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

SiteHeaderController.$inject = ['$window', '$interval', '$timeout', 'CbsiService', 'HeaderConstants'];


var _ = {
    isUndefined: _isUndefined3.default
};

var _module = _angular2.default.module('cb.ui-components.site-header.site-header-controller', []);

_module.controller('SiteHeaderController', SiteHeaderController);

exports.default = _module;


function SiteHeaderController($window, $interval, $timeout, CbsiService, HeaderConstants) {
    var vm = this;

    vm.showFoldout = showFoldout;
    vm.showCategory = showCategory;
    vm.toggleFoldout = toggleFoldout;
    vm.mouseout = mouseout;
    vm.closeMenu = closeMenu;
    vm.toggleMenu = toggleMenu;
    vm.toggleSearch = toggleSearch;
    vm.searchIsOpen = false;
    vm.showOverlay = false;
    vm.foldout = '';
    vm.category;
    vm.categoryIsOpen = false;
    vm.foldoutIsOpen = false;
    vm.menuIsOpen = false;
    vm.back = back;

    vm.isSignedIn = false;
    vm.isBusinessCustomer = false;
    vm.ingelogdNaam = 'Mijn Centraal Beheer';

    vm.isSticky = isSticky;

    var timer = [];

    function isSticky() {
        if ($window && $window._st && $window._st.cookiepermission) {
            var cookiePreference = $window._st.cookiepermission.getCookiePreferences();
            return cookiePreference[1] && cookiePreference[2] && cookiePreference[3];
        } else {
            return true;
        }
    }

    function showFoldout(name, event) {
        if (event && event.type == 'mouseover' && window.innerWidth < 768 && !('ontouchstart' in window)) {
            return;
        } else if ('ontouchstart' in window) {
            event.preventDefault();
        }

        if (vm.foldoutIsOpen === true && name === vm.foldout) {
            return closeMenu();
        }

        vm.foldout = name;
        vm.showOverlay = true;
        vm.foldoutIsOpen = true;
        vm.menuIsOpen = true;
        vm.searchIsOpen = false;
        vm.userMenuIsOpen = false;

        var defaultCategory = event.currentTarget.getAttribute('default-category');
        if (defaultCategory && window.innerWidth >= 768) {
            showCategory(defaultCategory);
        }
    }

    function closeFoldout(name, event) {
        vm.foldout = '';
        vm.showOverlay = false;
        vm.foldoutIsOpen = false;
        vm.menuIsOpen = false;
        vm.searchIsOpen = false;
        vm.categoryIsOpen = false;
        vm.category = '';
    }

    function toggleFoldout(name, event) {
        if (vm.foldout == name) {
            closeFoldout(name, event);
        } else {
            showFoldout(name, event);
        }
    }

    function showCategory(name, event) {
        if (event && event.type == 'mouseover' && window.innerWidth < 768 && !('ontouchstart' in window)) {
            return;
        }

        timer[name] = $timeout(function () {
            vm.categoryIsOpen = true;
            vm.category = name;
            $timeout.cancel(timer[name]);
        }, 150);
    }

    function mouseout(name) {
        $timeout.cancel(timer[name]);
    }

    function toggleMenu() {
        vm.menuIsOpen = !vm.menuIsOpen;

        if (vm.menuIsOpen) {
            vm.categoryIsOpen = false;
            vm.foldoutIsOpen = false;
            vm.category = '';
            vm.foldout = '';
        }
    }

    function toggleSearch() {
        closeMenu();
        vm.searchIsOpen = !vm.searchIsOpen;
    }

    function closeUtils() {
        closeMenu();
        vm.searchIsOpen = !vm.searchIsOpen;
    }

    function closeMenu() {
        vm.foldout = '';
        vm.showOverlay = false;
        vm.menuIsOpen = false;
        vm.foldoutIsOpen = false;
    }

    function back() {
        if (vm.categoryIsOpen) {
            vm.categoryIsOpen = false;
            vm.category = '';
        } else if (vm.foldoutIsOpen) {
            vm.foldoutIsOpen = false;
            vm.foldout = '';
        } else {
            closeMenu();
        }
    }

    if (CbsiService.getCbsiContext()) {
        vm.isSignedIn = CbsiService.isUserLoggedIn();
        vm.isBusinessCustomer = CbsiService.isBusinessCustomer();
        if (vm.isSignedIn) {
            tryParseCustomerData();
            customerDataPromise = $interval(tryParseCustomerData, 1500, 10);
        }
    }

    function getCustomerPersonalData() {
        var storageObj = null;
        if ($window.sessionStorage) {
            storageObj = $window.sessionStorage.getItem('cbData.mijnGegevens') || $window.sessionStorage.getItem('cbData.zakelijk.mijnGegevens'); // particulier of zakelijk
        }
        return storageObj;
    }

    function parseCustomerData(data) {
        var personalData = data.persoonsgegevens || data.contactgegevens.contactpersoon; // particulier of zakelijk
        if (personalData) {
            var name = '';
            if (personalData.aanhef) {
                if (personalData.aanhef.toLowerCase() === 'de heer') {
                    name += 'Dhr. ';
                }
                if (personalData.aanhef.toLowerCase() === 'mevrouw') {
                    name += 'Mevr. ';
                }
            }
            if (personalData.naam) {
                name += personalData.naam;
            }
            vm.ingelogdNaam = name;
        }

        //Generate optional menu items based on products customer owns
        vm.menuitems = [];
        // add fondsbeleggen if customer has product
        if (data.populated === true && data.productgroepIndicatoren) {
            if (data.productgroepIndicatoren.heeftFondsbeleggenGemaksbeleggen === true) {
                var menuitem = {};
                menuitem.iconclass = 'cb-iconfont-arrow-right';
                menuitem.link = HeaderConstants.FONDSBELEGGEN_URL;
                menuitem.text = 'Mijn Beleggen';
                if ($window.location.href.indexOf('acc-www') !== -1) {
                    menuitem.link = HeaderConstants.FONDSBELEGGEN_URL_ACC;
                }
                vm.menuitems.push(menuitem);
            }
        }
    }

    var customerDataPromise;

    function tryParseCustomerData() {
        var storageObj = getCustomerPersonalData();
        if (storageObj) {
            var mijnGegevens = JSON.parse(storageObj);
            if (mijnGegevens.populated === true || mijnGegevens.contactgegevens && mijnGegevens.contactgegevens.populated === true) {
                $interval.cancel(customerDataPromise);
                parseCustomerData(mijnGegevens);
            }
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/site-header/site-header.controller.js
// module id = 910
// module chunks = 0